export function normalizeMetrics(metrics: any) {
  if (!metrics) {
    return { views: "-", likes: "-", comments: "-", shares: "-" };
  }

  // Extract common metrics based on different platform DTOs
  const likes = metrics.likes ?? metrics.like_count ?? "-";
  const comments = metrics.comments ?? metrics.comment_count ?? "-";
  const shares = metrics.shares ?? metrics.share_count ?? "-";
  // Views can be view_count, video_views, or views
  const views = metrics.views ?? metrics.view_count ?? metrics.video_views ?? "-";

  return { views, likes, comments, shares };
}
